<template>
  <section class="product-two">
    <div class="container-carousel">
      <div class="product-two__top">
        <div class="container">
          <h3 class="product-one__title title-red">{{ t('brandSection.title') }}</h3>
        </div>
      </div>

      <div id="brandCarousel" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-inner">
          <!-- Skeleton Loader -->
          <div v-if="isLoading" class="carousel-item active">
            <div class="brands-wrapper">
              <div v-for="n in itemsPerPage" :key="n" class="brand-item skeleton-loader">
                <div class="product__item">
                  <div class="product__item__img brand-img-container">
                    <div class="skeleton-box skeleton-img"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Conteúdo real -->
          <div
            v-else
            class="carousel-item"
            :class="{ active: index === 0 }"
            v-for="(brandChunk, index) in chunkedBrands"
            :key="index"
          >
            <div class="brands-wrapper">
              <router-link
                v-for="(brand, idx) in brandChunk"
                :key="brand.id"
                :to="{ name: 'marca', params: { brandSlug: brand.slug, query: { page: 1 } } }"
                class="brand-item"
              >
                <div class="product__item">
                  <div class="product__item__img brand-img-container">
                    <img
                      v-if="brand.logo"
                      :src="brand.logo"
                      :alt="brand.nome"
                    />
                    <img
                      v-else
                      :src="require('@/assets/images/marca-sem-imagem.png')"
                      :alt="t('brandSection.noImage')"
                      class="default-img"
                    />
                    <div v-if="!brand.logo" class="brand-name">{{ brand.nome }}</div>
                  </div>
                  <div class="product-arrow">➔</div>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <div class="carousel-controls" v-if="!isLoading">
          <button
            class="carousel-control-prev custom-carousel-control"
            type="button"
            data-bs-target="#brandCarousel"
            data-bs-slide="prev"
          >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">{{ t('brandSection.previous') }}</span>
          </button>
          <button
            class="carousel-control-next custom-carousel-control"
            type="button"
            data-bs-target="#brandCarousel"
            data-bs-slide="next"
          >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">{{ t('brandSection.next') }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useI18n } from 'vue-i18n';
import { fetchBrands } from '@/services/apiService';

export default {
  name: 'BrandSection',
  setup() {
    const { t } = useI18n();

    const brands = ref([]);
    const chunkedBrands = ref([]);
    const itemsPerPage = ref(5);
    const isLoading = ref(true);

    const chunkArray = (array, chunkSize) => {
      const result = [];
      for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
      }
      return result;
    };

    const fetchAndSetBrands = async () => {
      isLoading.value = true;
      try {
        const allBrands = await fetchBrands();
        const validBrands = allBrands.filter(brand => brand.logo && brand.logo.trim() !== '');
        brands.value = validBrands;
        chunkedBrands.value = chunkArray(validBrands, itemsPerPage.value);
      } catch (error) {
        console.error('Erro ao buscar marcas:', error);
      } finally {
        isLoading.value = false;
      }
    };

    const updateChunkedBrands = () => {
      const width = window.innerWidth;
      if (width < 768) {
        itemsPerPage.value = 1;
      } else if (width < 1000) {
        itemsPerPage.value = 2;
      } else if (width < 1200) {
        itemsPerPage.value = 3;
      } else {
        itemsPerPage.value = 5;
      }
      chunkedBrands.value = chunkArray(brands.value, itemsPerPage.value);
    };

    onMounted(() => {
      fetchAndSetBrands();
      updateChunkedBrands();
      window.addEventListener('resize', updateChunkedBrands);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateChunkedBrands);
    });

    return {
      t,
      brands,
      chunkedBrands,
      itemsPerPage,
      isLoading
    };
  }
};
</script>

<style scoped>
.product-two {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 50px 0;
  margin: 0 auto;
  max-width: 1200px;
}

.title-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
  border-radius: 10px;
}

.brands-container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  max-width: 100%;
}
.brand-img-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  padding: 4px 8px 10px;
  box-sizing: border-box;
}

.brand-img-container img {
  width: 100% !important;
  height: 100% !important;
  object-fit: contain !important;
  object-position: center;
  margin: 0;
  max-width: none !important;
  max-height: none !important;
  mix-blend-mode: normal !important;
   top: -4px;
}

.product-one__title::after {
  position: absolute;
  right: 1px;
  top: 0;
  bottom: 0;
  
  width: calc(100% - 140px);
  height: 2px;
  content: "";
  background-color: var(--karoons-border-color, #DEDEDE);
}

.product__item {
  text-align: center;
  border-radius: 10px;
  background-image: url('@/assets/images/fundo-das-marcas.png');
  background-size: cover;
  background-position: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  background-color: #F7F7F7;
  padding-top: 10px;
}

.brands-wrapper {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}


.brand-item {
  flex: 0 0 auto;
  min-width: 200px;
  margin: 0 10px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #E23B33;

  width: calc(20% - 20px);
  overflow: hidden;
  height: 270px;
}

.product-arrow {
  color: #E23B33;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: 15px;
  right: 15px;
  cursor: pointer;
  background-color: white;
}

.title-red {
  color: rgba(226, 59, 51, 0.8);
  margin-bottom: 20px;
  font-size: 2.3rem;
  max-width: 1170px;
  margin: 0 auto;
}

.custom-carousel-control {
  background-color: #E23B33;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.8;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.custom-carousel-control:hover {
  background-color: #C12E29;
  opacity: 1;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  width: 12px;
  height: 12px;
}

.carousel-controls {
  position: absolute;
  top: 50%;
  width: calc(100% + 80px);
  left: -40px;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.skeleton-loader {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  border-radius: 10px;
}

.skeleton-box {
  background-color: #e0e0e0;
  border-radius: 8px;
  animation: pulse 1.5s infinite ease-in-out;
}

.skeleton-img {
  width: 100%;
  height: 170px;
  margin-top: 20px;
}

@keyframes pulse {
  0% {
    background-color: #e0e0e0;
  }
  50% {
    background-color: #f0f0f0;
  }
  100% {
    background-color: #e0e0e0;
  }
}
@media (max-width: 1200px) {
  .carousel-controls {
    width: 100%;
    left: 0;
  }

  .carousel-control-prev {
    left: 10px;
  }

  .carousel-control-next {
    right: 10px;
  }
}

@media (max-width: 768px) {

  .carousel-control-prev,
  .carousel-control-next {
    width: 30px;
    height: 30px;
  }

  .carousel-control-prev {
    left: 15px;
  }

  .carousel-control-next {
    right: 15px;
  }
}

@media (max-width: 576px) {

  .carousel-control-prev,
  .carousel-control-next {
    width: 25px;
    height: 25px;
  }

  .carousel-control-prev {
    left: 20px;
  }

  .carousel-control-next {
    right: 20px;
  }
}

.default-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin-top: 20px;
}

.brand-name {
  font-size: 1rem;
  color: #333;
  transition: transform 500ms ease, color 500ms ease;
  transform: scale(1);
  display: inline-block;
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%) scale(1);
  font-size: 1.5rem;
  color: #393939;
  font-weight: 900;
  text-transform: uppercase;
  width: 100%;
  text-align: center;
  z-index: 2;
}

.product__item:hover .brand-name {
  transform: translateX(-50%) scale(1.1);
  color: #000;
}

.product__item:hover .brand-name {
  transform-origin: center center;
}
@media (max-width: 768px) {
  .brand-item {
    width: 70% !important;
    height: 320px !important;
    margin: 0 auto;
  }

  .product__item {
    height: 100%;
  }

  .skeleton-img {
    height: 220px;
  }

  .brand-name {
    font-size: 1.7rem;
  }
}

</style>
